import fx from "money";

export const convertCurrency = (val,to) => {
  fx.base = "USD";
  fx.rates = {
    USD: 1,
    AED: 3.67,
    AFN: 86.3,
    ALL: 96.39,
    AMD: 387.14,
    ANG: 1.79,
    AOA: 828.65,
    ARS: 257.95,
    AUD: 1.49,
    AWG: 1.79,
    AZN: 1.7,
    BAM: 1.8,
    BBD: 2,
    BDT: 108.34,
    BGN: 1.8,
    BHD: 0.376,
    BIF: 2811.04,
    BMD: 1,
    BND: 1.35,
    BOB: 6.91,
    BRL: 4.81,
    BSD: 1,
    BTN: 82.02,
    BWP: 13.47,
    BYN: 2.82,
    BZD: 2,
    CAD: 1.32,
    CDF: 2335.12,
    CHF: 0.896,
    CLP: 799.22,
    CNY: 7.22,
    COP: 4159.23,
    CRC: 543.65,
    CUP: 24,
    CVE: 101.25,
    CZK: 21.78,
    DJF: 177.72,
    DKK: 6.85,
    DOP: 55.03,
    DZD: 135.62,
    EGP: 30.92,
    ERN: 15,
    ETB: 54.96,
    EUR: 0.918,
    FJD: 2.22,
    FKP: 0.786,
    FOK: 6.85,
    GBP: 0.786,
    GEL: 2.6,
    GGP: 0.786,
    GHS: 11.54,
    GIP: 0.786,
    GMD: 62.65,
    GNF: 8529.88,
    GTQ: 7.84,
    GYD: 211.46,
    HKD: 7.83,
    HNL: 24.63,
    HRK: 6.92,
    HTG: 138.5,
    HUF: 344.39,
    IDR: 15014.41,
    ILS: 3.71,
    IMP: 0.786,
    INR: 82.02,
    IQD: 1312.12,
    IRR: 41990.03,
    ISK: 136.62,
    JEP: 0.786,
    JMD: 153.81,
    JOD: 0.709,
    JPY: 144.45,
    KES: 140.57,
    KGS: 87.15,
    KHR: 4148.9,
    KID: 1.49,
    KMF: 451.76,
    KRW: 1297.32,
    KWD: 0.307,
    KYD: 0.833,
    KZT: 445.67,
    LAK: 19118.37,
    LBP: 15000,
    LKR: 306.13,
    LRD: 182.48,
    LSL: 18.65,
    LYD: 4.81,
    MAD: 9.77,
    MDL: 18.33,
    MGA: 4512.06,
    MKD: 56.42,
    MMK: 2099.49,
    MNT: 3449.94,
    MOP: 8.07,
    MRU: 34.45,
    MUR: 45.45,
    MVR: 15.44,
    MWK: 1058.16,
    MXN: 17.05,
    MYR: 4.65,
    MZN: 63.94,
    NAD: 18.65,
    NGN: 763.9,
    NIO: 36.55,
    NOK: 10.65,
    NPR: 131.24,
    NZD: 1.61,
    OMR: 0.384,
    PAB: 1,
    PEN: 3.63,
    PGK: 3.58,
    PHP: 55.26,
    PKR: 280.22,
    PLN: 4.07,
    PYG: 7270.24,
    QAR: 3.64,
    RON: 4.54,
    RSD: 107.56,
    RUB: 89.89,
    RWF: 1213.89,
    SAR: 3.75,
    SBD: 8.49,
    SCR: 13.11,
    SDG: 530.38,
    SEK: 10.83,
    SGD: 1.35,
    SHP: 0.786,
    SLE: 18.72,
    SLL: 18721.47,
    SOS: 569.65,
    SRD: 37.5,
    SSP: 985.34,
    STN: 22.5,
    SYP: 2514.99,
    SZL: 18.65,
    THB: 34.88,
    TJS: 10.9,
    TMT: 3.5,
    TND: 3.1,
    TOP: 2.37,
    TRY: 26.02,
    TTD: 6.75,
    TVD: 1.49,
    TWD: 31.1,
    TZS: 2422.34,
    UAH: 36.93,
    UGX: 3674.79,
    UYU: 37.51,
    UZS: 11458.67,
    VES: 28.16,
    VND: 23613.32,
    VUV: 119.45,
    WST: 2.72,
    XAF: 602.34,
    XCD: 2.7,
    XDR: 0.751,
    XOF: 602.34,
    XPF: 109.58,
    YER: 250.38,
    ZAR: 18.65,
    ZMW: 17.67,
    ZWL: 5823.61,
  };
  const pounds = fx(val).from("USD").to(to);
  return pounds.toFixed(2);
};
